import ShopAddressSettingsForm from './shop-address-settings-form';

export default ShopAddressSettingsForm;
